import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { FUEL_OPTIONS, METER_TYPE_ERROR_CODES } from 'config/app-config';
import { actionUrl } from 'config/static-content';
import { useIsExistingCustomer } from 'components/direct-sales/select-options/hooks/useIsExistingCustomer';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

type DataMaping = {
  gas: boolean;
  electric: boolean;
  decoration: 'dualFuel' | 'gas' | 'bulb' | undefined;
  fuelName: string;
};

const dataMaping: DataMaping[] = [
  {
    gas: true,
    electric: true,
    decoration: 'dualFuel',
    fuelName: 'energy'
  },
  {
    gas: true,
    electric: false,
    decoration: 'gas',
    fuelName: FUEL_OPTIONS.GAS
  },
  {
    gas: false,
    electric: true,
    decoration: 'bulb',
    fuelName: FUEL_OPTIONS.ELECTRIC
  }
];

const getData = ({ gas, electric }) => {
  return (
    dataMaping.find(
      (data) => data.gas === gas && data.electric === electric
    ) ?? { decoration: undefined, fuelName: '' }
  );
};

type ChangeTariffCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const ChangeTariffCard = ({ errors, name }: ChangeTariffCardProps) => {
  const {
    isExistingNEPCustomer,
    isExistingBGCustomer,
    isExistingCustomer
  } = useIsExistingCustomer({ errors });

  const changeTariffUrl =
    isExistingNEPCustomer.gas || isExistingNEPCustomer.electric
      ? actionUrl.nepChangeTariff
      : actionUrl.bgClassicChangeTariff;

  const { decoration, fuelName } = getData({
    gas: isExistingNEPCustomer.gas || isExistingBGCustomer.gas,
    electric: isExistingNEPCustomer.electric || isExistingBGCustomer.electric
  });

  if (!isExistingCustomer) {
    return null;
  }

  return (
    <NsCard
      heading="Already a British Gas energy customer?"
      action={
        <TrackedCta name={name}>
          <NsPrimaryCta href={changeTariffUrl} testId="changeTariffCtaTestId">
            Change tariff
          </NsPrimaryCta>
        </TrackedCta>
      }
      decoration={decoration}
      testId="changeTariffCardTestId"
    >
      <p>
        Already with us for your {fuelName}? Then it&apos;s quick to change to a
        new tariff online.
      </p>
    </NsCard>
  );
};
